<template>
  <div
    class="h-auto md:h-12 bg-black flex justify-between items-center px-12 w-full flex-wrap md:flex-nowrap py-6 lg:py-0"
  >
    <h6
      class="text-white text-sm m-0 w-full md:w-auto mb-2 md:mb-0 text-center md:text-left"
    >
      CareerWise © {{ year }}.
    </h6>
    <div
      class="flex flex-wrap md:flex-nowrap md:space-x-4 space-y-2 md:space-y-0 w-full md:w-auto mt-6 md:mt-0"
    >
      <a
        href="/account"
        class="text-sm font-primary font-bold text-white no-underline cursor-pointer w-full md:w-auto text-center md:text-left hover:text-cw-alt"
      >
        Sign in
      </a>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'

export default {
  name: 'Footer',

  setup() {
    const year = ref(null)

    onMounted(() => {
      const d = new Date()
      year.value = d.getFullYear()
    })

    return {
      year,
    }
  },
}
</script>
